module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1AODxk3/tc-custom/9781398468757.jpg?1721404630410",
      "alt": "This image is the cover for the book Soul Fire"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Soul Fire\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In this village, breaking the laws brings swift death in the wake of night. The community lives in careful balance, each person has their place, and every rule is obeyed. Except for Luna, an outcast girl who does not behave as she should. They call her ‘freak’ because she does not keep to her place. She is different: an outlier. When monsters emerge, filling the nights with horror and shadows, terror spirals through the village. But Luna sees a chance amidst the chaos to carve out a new place for herself. A chance to finally demonstrate her combat abilities, much to the Leader’s dismay. Luna wants to fight, and she will train, work, and beg as hard as it takes to earn that place. She is a warrior, and the monsters are coming. All must fight.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Penelope Alice\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Penelope Alice is a software engineer. Raised in Buckinghamshire, she spends many happy hours walking in the countryside and visiting the local attractions. From a young age, Penelope has wanted to be a writer. She usually feels most relaxed making up stories and new worlds. Penelope’s passions include playing cello in her local orchestra, watching anime and drinking far too much tea.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0